/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Csv_Import_FailedInputs */



/**
* | output |
* | --- |
* | "{count} player(s) could not be registered:" |
*
* @param {Csv_Import_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const csv_import_failed = /** @type {((inputs: Csv_Import_FailedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_Import_FailedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} joueur(s) n'ont pas pu être inscrit(s) :`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} jugador/es no pudieron ser inscrito/s:`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} jogador/es não puderam ser inscrito/s:`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} giocatore/i che non è stato possibile iscrivere:`)
	return /** @type {LocalizedString} */ (`${i?.count} player(s) could not be registered:`)
});